import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot } from "vue"
import _imports_0 from '@assets/img/routerBack.png'


const _hoisted_1 = { class: "page" }
const _hoisted_2 = { class: "page-header" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "d-flex" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.showBack)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.routerBack && _ctx.routerBack(...args))),
            class: "routerBack pointer"
          }, _hoisted_4))
        : _createCommentVNode("", true),
      _createElementVNode("div", null, _toDisplayString(_ctx.name), 1),
      _createElementVNode("div", _hoisted_5, [
        _renderSlot(_ctx.$slots, "header")
      ])
    ]),
    _renderSlot(_ctx.$slots, "default")
  ]))
}